import { LeaderboardFilter, LeaderboardPositionDto, ListWithTotals } from '@sweatpals/shared';
import { AxiosInstance } from 'axios';

export class LeaderboardService {
	private readonly basePath = 'leaderboard';

	constructor(private readonly httpClient: AxiosInstance) {}

	public async getRevenueLeaderboard(params: LeaderboardFilter): Promise<ListWithTotals<LeaderboardPositionDto>> {
		const { data } = await this.httpClient.get<ListWithTotals<LeaderboardPositionDto>>(
			`${this.basePath}/public/revenue`,
			{
				params,
			}
		);
		return data;
	}

	public async getRsvpsLeaderboard(params: LeaderboardFilter): Promise<ListWithTotals<LeaderboardPositionDto>> {
		const { data } = await this.httpClient.get<ListWithTotals<LeaderboardPositionDto>>(
			`${this.basePath}/public/rsvps`,
			{
				params,
			}
		);
		return data;
	}
}
